import { useNavigate } from 'react-router-dom'
import Button from '../Button/Button'
import './EventcardStyle.css'
import React from 'react'

const Eventcard = ({ cardimg, type, heading, countreg, time, date, contact, onClick,alt }) => {

    const navigate = useNavigate()

    return (
        <div className='eventcardbox' onClick={onClick}>
            <div className="eventcardbanner">
                <img src={cardimg} alt={alt} className='cardeventimg' />
            </div>

            <div className="Adcardeventboxtext">
                <div className="styleevntitle">
                    {type}
                </div>

                <h3 className='texth3event'>{heading}</h3>

                <div className="regevetCardAd">
                    <h4 className='text3 mb4'>Registrations:</h4>
                    <p>{countreg}</p>
                </div>

                <div className="timeAdevetcard flex gap-10">
                    <div className="borderevent"></div>
                    <span className='text3'>{time}</span>
                </div>

                <div className="EventcardfooterAd flex">
                    <div className="calEventleftAd flex">
                        <img src="/assets/img/calendarblue.png" alt="" />
                        <span className='text2'>{date}</span>
                    </div>

                    <div className='zoombtn' onClick={() => window.open(contact)}>{"Zoom"}</div>
                </div>
            </div>

        </div>
    )
}

export default Eventcard